import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { TModalsState, setModalsData } from "../../../api/store/commonSlice";
import { TReport, TReportStatus } from "../../../api/types/Report";
import { AdminFormFieldSubmit } from "../../../components/admin/formFields";
import FTModal from "../../../components/common/FTModal";
import { REPORT_CATEGORIES, REPORT_TYPES } from "../../../constants/constants";
import { useCreateCustomReportContext } from "../context/createCustomReport.context";

const NEW_CUSTOM_CATEGORIES = [
  REPORT_CATEGORIES.NEW_CUSTOM_ASSET,
  REPORT_CATEGORIES.NEW_CUSTOM_DRIVER,
  REPORT_CATEGORIES.NEW_CUSTOM_USER,
];

const ModalCreateCustomReportsStep1 = () => {
  const { t: tTitles } = useTranslation("translation", {
    keyPrefix: "reports.titles",
  });
  const { t } = useTranslation("translation", {
    keyPrefix: "reports.createCustomReport.step1",
  });

  const dispatch = useDispatch();
  const modalsState: TModalsState = useSelector(
    (state: any) => state.commonReducer.modals
  );

  const reportsByType: { [key: string]: TReport[] | TReportStatus } =
    useSelector((state: any) => state.commonReducer.reportsByType);

  const { setSelectedReportId } = useCreateCustomReportContext();

  // we don't need to fetch the reports by category
  // as the same is already fetched in the `reportsByType` state
  // -----------------------------------------------------------
  // const reportTypeCategoryParams = {
  //   type: REPORT_TYPES.NEW_CUSTOM,
  //   // category: REPORT_CATEGORIES[reportCategoryIndex.current],
  //   page: 1,
  //   page_size: APP_CONFIG.LISTINGS.LARGE_PAGE_SIZE,
  // }
  // const {
  //   data: dataReportsByCategory,
  //   isFetching: isFetchingreportsByCategory,
  // } =
  //   useGetReportsByCatTypeQuery(reportTypeCategoryParams);

  const hideModal = () => {
    dispatch(
      setModalsData({
        ...modalsState,
        showModalNewCustomReportStep1: false,
        showModalNewCustomReportStep2: false,
        showModalNewCustomReportStep3: false,
      })
    );
  };

  const selectReportId = (reportId: number) => {
    // select the report category
    setSelectedReportId(reportId);
    // show the next step
    dispatch(
      setModalsData({
        ...modalsState,
        showModalNewCustomReportStep1: false,
        showModalNewCustomReportStep2: true,
        showModalNewCustomReportStep3: false,
      })
    );
  };

  return (
    <FTModal
      visible={modalsState.showModalNewCustomReportStep1}
      containerStyle="max-w-[calc(100vw-4rem)] w-[903px]"
      dismissible={true}
      heading={t("heading")}
      onHide={hideModal}
      position="center"
    >
      <div className="grid grid-cols-3 gap-8">
        {/* <pre className="text-[8px]">{JSON.stringify(reportsByType[REPORT_TYPES.NEW_CUSTOM], null, 2)}</pre> */}

        {/* Sub Header */}
        <div className="mb-2 col-span-3 text-heading-gray888">
          {t("sub_heading")}
        </div>

        {/* Category Sections */}
        {NEW_CUSTOM_CATEGORIES.map((category, categoryIndex) => (
          <div className="flex flex-col gap-5" key={categoryIndex}>
            <div className="text-accent-blue-dark font-semibold leading-6 p-3 border-b border-black/20">
              {tTitles(`report_category_${category}`)}
            </div>
            {Array.isArray(reportsByType[REPORT_TYPES.NEW_CUSTOM]) && (
              <div className="flex flex-col gap-2">
                {(reportsByType[REPORT_TYPES.NEW_CUSTOM] as TReport[])
                  ?.filter(
                    (report: TReport) => report?.category === parseInt(category)
                  )
                  ?.map((item) => (
                    <AdminFormFieldSubmit
                      buttonDimensionClass="h-12 w-full px-4"
                      key={item.id}
                      variant="primary-like"
                      label={item.name}
                      id={`submit-button-${item.id}`}
                      onClick={() => {
                        selectReportId(item.id);
                      }}
                    />
                  ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </FTModal>
  );
};

export default ModalCreateCustomReportsStep1;
